import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const RestrictedRoute = (props) => {
  const { changeUserData, userData } = useContext(AuthContext);

  if (userData.isAuthenticated) {
    return <Outlet />;
  } else {
    const userData = sessionStorage.getItem("userData");
    if (userData) {
      const user = JSON.parse(userData);
      changeUserData({
        user,
        usertype: userData.usertype,
        userRole: userData.role,
        isAuthenticated: true,
      });

      return <Outlet />;
    } else {
      return <Navigate to="/log-in" replace />;
    }
  }
};

export default RestrictedRoute;
